import PropTypes from 'prop-types'
import React from 'react'
import {
  Overlay
} from 'react-bootstrap'
import classes from './Backdrop.module.scss'

const Backdrop = ({ children, className, ...restProps }) => {
  let compClassName = classes.backdrop
  if (className) compClassName += ' ' + className

  return (
    <Overlay show>
      <div
        {...restProps}
        className={compClassName}
       />
    </Overlay>
  )
}

Backdrop.propTypes = {
  className: PropTypes.string
}

export default Backdrop

